import React, { memo } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { BaseButton, ButtonTypes } from 'components/base/BaseButton';

import css from './buyStickerPopupSuccess.module.sass';

interface Props {
  defaultPackPreviewUrl?: string;
  defaultStickerPreviewUrl?: string;
  stickersPacksImages: string[];
  onSubmit: () => void;
}

export const BuyStickerPopupSuccess: React.FC<Props> = memo(
  ({
    defaultPackPreviewUrl,
    defaultStickerPreviewUrl,
    stickersPacksImages,
    onSubmit,
  }) => {
    const { t } = useTranslation(['app']);

    const { handleSubmit } = useForm();

    return (
      <>
        <h2 className={css.title}>{t('app:stickers.buy.title')}</h2>
        <p className={css.subtitle}>{t('app:stickers.bought.subtitle')}</p>

        {!!stickersPacksImages.length && (
          <div className={css.successImages}>
            {stickersPacksImages.map((stickerImage) => (
              <img
                key={stickerImage}
                className={css.successImage}
                src={stickerImage}
              />
            ))}
          </div>
        )}

        {!stickersPacksImages.length && (
          <img
            className={css.successImage}
            src={defaultPackPreviewUrl || defaultStickerPreviewUrl}
          />
        )}

        <p className={css.subtitle}>{t('app:stickers.bought.more')}</p>
        <form className={css.form} onSubmit={handleSubmit(onSubmit)}>
          <BaseButton
            nativeType="submit"
            type={ButtonTypes.Accent}
            className={css.sendBtn}
          >
            {t('app:stickers.bought.view')}
          </BaseButton>
        </form>
      </>
    );
  }
);
